// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__2Wn0I","input":"Checkbox_input__s0QyL","label":"Checkbox_label__qWLb_","error":"Checkbox_error__haSHE"};